export interface DeviceIssueType {
  id: string;
  text: string;
  icon: React.ReactNode;
}

export const VENDOR_MAPPING: Record<string, string> = {
  medtronic: 'Medtronic',
  abbott: 'Abbott',
  biotronik: 'Biotronik',
  boston_scientific: 'Boston Scientific',
  sorin: 'Sorin'
};
